export default __webpack_public_path__ + "static/media/ArrowRedUp.e1667f9c.svg";